import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import {
  MDSPlanCard,
  MDSPlanCardSlot,
  MDSPlanCardBackground,
  MDSPlanCardBorder,
  MDSPlanId,
  MDSIcon,
  MDSIconKind,
} from "@/mds";
import { MDSBadge, MDSBadgeVariant } from "@/mds/components/badge";
import {
  getFreeFeatures,
  getProFeatures,
} from "@/pages/settings/components/subscription-management/data";
import { TitleAndBadgeContainer } from "@/pages/settings/components/subscription-management/subscription.styles";
import { MDSButton, MDSButtonVariant } from "@/mds";
import { CardsRow } from "@/pages/settings/components/subscription-management/subscription.styles";
import styled from "@emotion/styled";
import { useAppStore } from "@/store/utils/hooks";
import { observer } from "mobx-react-lite";

interface Props {
  subscriptionStatusText: string;
  downgradePreposition: string;
  onSubscribe: () => void;
}

export const CanceledPlanManagement: React.FC<Props> = observer(
  ({ subscriptionStatusText, downgradePreposition, onSubscribe }) => {
    const { store } = useAppStore();
    const pdfPaywallEnabled = store.spaceAccountFeatureFlags.getFlagStatus("pdf-paywall") ?? false;
    return (
      <>
        <TitleAndBadgeContainer>
          <MDSText variant={MDSTextVariant.HeaderL}>Pro Plan</MDSText>
          <MDSBadge
            label={`Downgrading ${downgradePreposition}`}
            variant={MDSBadgeVariant.Negative}
            icon={MDSIconKind.Warning}
          />
        </TitleAndBadgeContainer>

        <StyledText>{subscriptionStatusText}</StyledText>

        <CardsRow $columns>
          {/* Free plan  */}
          <MDSPlanCard
            plan={MDSPlanId.Free}
            features={getFreeFeatures({ pdfPaywallEnabled })}
            border={MDSPlanCardBorder.Default}
            background={MDSPlanCardBackground.None}
          >
            <MDSText
              variant={MDSTextVariant.HeaderL}
              weight={MDSTextWeight.SemiBold}
              slot={MDSPlanCardSlot.Title}
            >
              Free
            </MDSText>
            <MDSBadge
              label="After downgrade"
              variant={MDSBadgeVariant.Default}
              slot={MDSPlanCardSlot.TitleBadge}
            />

            <div slot={MDSPlanCardSlot.Price}>Free forever</div>
          </MDSPlanCard>

          {/* Pro plan */}
          <MDSPlanCard
            plan={MDSPlanId.Paid}
            features={getProFeatures({ pdfPaywallEnabled })}
            border={MDSPlanCardBorder.Emphasis}
            background={MDSPlanCardBackground.Emphasis}
          >
            <MDSText
              variant={MDSTextVariant.HeaderL}
              weight={MDSTextWeight.SemiBold}
              slot={MDSPlanCardSlot.Title}
            >
              Pro
            </MDSText>
            <MDSBadge
              label="Best for your usage"
              variant={MDSBadgeVariant.MoreEmphasis}
              slot={MDSPlanCardSlot.TitleBadge}
            />
            <div slot={MDSPlanCardSlot.Price}>$12 / month</div>
            <MDSButton
              variant={MDSButtonVariant.Emphasis}
              onClick={onSubscribe}
              slot={MDSPlanCardSlot.Footer}
            >
              <MDSIcon kind={MDSIconKind.StarSolid} />
              Subscribe to Pro
            </MDSButton>
          </MDSPlanCard>
        </CardsRow>
      </>
    );
  }
);

const StyledText = styled(MDSText)(({ theme }) => ({
  margin: `${theme.spacing[5]} 0`,
}));
